import qs from 'qs';
import { showLoader } from './webview.utils';
import { schedulingHistory } from './schedulingHistory';
import { proxyApiRequest } from '../api';

const controllerUrl = process.env.REACT_APP_CTRL_URL;
const epicAuthUrl = process.env.REACT_APP_EPIC_AUTH_URL;
const oauthRedirectUrl = process.env.REACT_APP_OAUTH_REDIRECT_URL;
const epicClientId = process.env.REACT_APP_EPIC_CLIENT_ID;
const epicAudKey = process.env.REACT_APP_EPIC_AUD_KEY;

const getQueryStringParams = (query) => {
	return query
		? (/^[?#]/.test(query) ? query.slice(1) : query).split('&').reduce(function (params, param) {
				let [key, value] = param.split('=');
				params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
				return params;
		  }, {})
		: {};
};

export function processLaunchCode(launch, pathname, params) {
	// console.log('redirecting to claim code', launch);
	const scope = 'launch';
	const clientId = epicClientId;
	const responseType = 'code';
	const redirectUri = encodeURI(oauthRedirectUrl);
	// set state to capture return path
	const state = window.btoa(JSON.stringify({ pathname, params }));

	console.log('processLaunchCode - oauthRedirectUrl', oauthRedirectUrl);
	console.log('processLaunchCode - redirectUri', redirectUri);
	console.log('processLaunchCode - state', state);

	return `${epicAuthUrl}?launch=${launch}&scope=${scope}&client_id=${clientId}&response_type=${responseType}&redirect_uri=${redirectUri}&state=${state}&aud=${epicAudKey}`;
}

export async function processFdi(props) {
	// console.log(`Checking for launch code`, window.location, window.location.pathname, window.location.search);
	// Check if there are query parameters
	if (localStorage) {
		localStorage.removeItem('token');
	}
	console.log('calling processFdi', props);
	if (window.location.search) {
		const parameters = qs.parse(window.location.search.substr(1));
		const pathname = encodeURI(window.location.pathname);
		// console.log('parameters', parameters);
		const { code, state, launch, params } = parameters;

		if (pathname === '/breakout' || pathname === '/alchemer-breakout') {
			// closeTopBar();
			// console.log('handing off');
			// set it so it's not a new refresh
			// console.log('Unflagging a new refresh');
			window.newRefresh = false;
			// if (pathname === '/breakout') {
			// 	schedulingHistory().push({ state: 'redirection', redirection: true, referrer: document.referrer });
			// }
			props.history.push({
				pathname: '/openScheduling',
				breakout: pathname,
				data: { detail: getQueryStringParams(window.location.search) },
			});
			return false;
		}
		// if there is a launch code, redirect to oauth page
		console.log('processFdi - parameters', parameters);
		if (launch) {
			showLoader();
			if (localStorage) {
				// clear out any existing tokens
				localStorage.removeItem('token');
			}

			const tokenURL = processLaunchCode(launch, pathname, params);
			console.log('processFdi - tokenURL', tokenURL);

			window.location.replace(tokenURL);
			return false;
		} else if (code) {
			let context = {};
			if (state) context = JSON.parse(window.atob(state));
			context.code = code;
			if (localStorage) {
				context.lastSession = localStorage.getItem('lastSession');
			}
			const data = {
				state: 'oauthLogin',
				event: '',
				context,
			};
			let nextPath = '/openScheduling';
			let passedData = {};
			if (context.pathname) {
				switch (context.pathname) {
					case '/dashboard':
						//console.log('in the dashboard return case', code);
						nextPath = '/dashboard';
						break;
					case '/resources':
						nextPath = '/desktop/resources';
						break;
					case '/care':
					case '/getCare':
						nextPath = '/desktop/getCare';
						// nextPath = '/openScheduling';
						// data.context = data.context || {};
						// data.context.oic = 'true';
						// nextPath = '/openScheduling';
						// data.context = data.context || {};
						// data.context.cc = 'true';
						break;
					case '/oic':
						nextPath = '/openScheduling';
						data.context = data.context || {};
						data.context.oic = 'true';
						break;
					case '/finddoc':
						nextPath = '/openScheduling';
						data.context = data.context || {};
						data.context.finddoc = 'true';
						break;
					case '/conditions':
						nextPath = '/openScheduling';
						data.context = data.context || {};
						data.context.conditions = 'true';
						break;
					case '/careConcierge':
						nextPath = '/openScheduling';
						data.context = data.context || {};
						data.context.cc = 'true';
						data.context.providerPhone = context.params ? context.params : '555-555-5555';
						break;
					default:
						nextPath = '/openScheduling';
						break;
				}
			}

			console.log('processFdi - nextPath', nextPath);
			if (
				localStorage &&
				localStorage.getItem('token') &&
				JSON.parse(localStorage.getItem('token')) &&
				JSON.parse(localStorage.getItem('token')).accessToken
			) {
				// send back to nextState
				props.history.replace({
					pathname: nextPath,
					data: {},
					source: 'oauthComplete',
				});
				return false;
			}

			console.log('sending in processFdi', data);
			const response = await proxyApiRequest(controllerUrl + '/oauth', data);
			console.log('processFdi proxyApiRequest', response);
			// clear out and then push
			schedulingHistory().clear();

			data.initial = true;
			schedulingHistory().push({
				parameters: data,
				state: response.data,
			});

			// console.log('da response', response);
			// if the access token exists, store it into localStorage for later use
			if (response && response.data && response.data.context && response.data.context.accessToken) {
				// console.log('Replacing token...');
				const context = response.data.context;
				const info = {
					accessToken: context.accessToken,
					fhirId: context.fhirId,
					dob: window.btoa(context.patientDOB),
					patientIds: context.patientIds,
				};
				if (localStorage) {
					localStorage.setItem('token', JSON.stringify(info));
				}
			}
			props.history.replace({
				pathname: nextPath,
				data: Object.assign(response, passedData),
				source: 'oauthComplete',
			});
			return false;
		}
	}
	return true;
}
